package com.downdogapp.client.views.start

import com.downdogapp.client.View

expect class StatsPageView() : View {

  fun refreshView()
  fun refreshCalendar()
}

object StatsPageViewConstants {

  val GOAL_ARROW_LEFT_MARGIN = 3
  val CALENDAR_SETTINGS_LEFT_MARGIN = 5
}
